import { IdiomaService } from './../providers/idioma/idioma.service';
import { Component, EventEmitter, Input, Output, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { AuthenticationService } from '../providers/authentication/authentication.service';
import { TranslateService } from 'ng2-translate';
import { AppComponent } from '../app.component';
import { ServiciosWebServiceProvider } from '../providers/web-service-service/servicios-web-service';
import { PermisosService, Permisos } from '../providers/authentication/permisos.service';
import { IdiomaCalendario } from '../domain/IdiomaCalendatio';


@Component({
  selector: 'app-formulario-contenido',
  templateUrl: './FormularioContenido.component.html'
})

export class FormularioContenidoComponent implements OnDestroy, OnChanges{

  @Input() contenidoSeleccionado: any;
  @Input() confirmacionVisible: boolean;
  @Input() msgs: any[];
  @Input() visible: boolean = true;

  @Output() onElementoGuardado: EventEmitter <any> = new EventEmitter();
  @Output() onElementoError: EventEmitter <any> = new EventEmitter();
  @Output() onElementoEliminado: EventEmitter <any> = new EventEmitter();
  @Output() onFormularioValidation: EventEmitter <boolean> = new EventEmitter();


  public isValid = true;
  public color;

  public operacion;


  blockUI: HTMLElement;
  spinner: HTMLElement;
  permisos: Permisos = new Permisos();
  idiomaCalendario: IdiomaCalendario;
  constructor(
	private appComponent: AppComponent,
      private entityManagerProvider: EntityManagerProvider,
	  public authService: AuthenticationService,
	  public idiomaService: IdiomaService,
	  public sws: ServiciosWebServiceProvider,
	  private translate: TranslateService,
	  private permisosService: PermisosService
	) {
		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';
		this.blockUI = document.getElementsByClassName('blockPosicionarContenido')[0] as HTMLElement;
		if (this.blockUI) {
			this.blockUI.style.display = 'none';
		}

		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');

		this.comprobarPermisos();
	}
	ngOnChanges(changes: SimpleChanges) {
		if(this.contenidoSeleccionado){
			let contenido = this.contenidoSeleccionado;
			if (contenido.Imagen === null || contenido.Imagen === undefined || contenido.Imagen === ''){
				contenido.Imagen = this.authService.getFotoPorDefecto();
			}
			this.contenidoSeleccionado = contenido;
		}
	}

	ngOnDestroy(): void {
		this.entityManagerProvider.RejectChanges();
	}



	/* Confirmacion */
	mostrarConfirmacion(operacion){
		this.appComponent.showWarn(operacion);
		this.operacion = operacion;
		this.confirmacionVisible = true;
	}

	confirmar(){
		this.msgs = [];
		if (this.operacion === 'guardar') {
			this.spinner.style.display = 'inherit';
			this.guardar();
		}
	}

	cancelar(){
		this.msgs = [];
		this.operacion = '';
		this.confirmacionVisible = false;
	}

	guardar(){

		this.contenidoSeleccionado.ENTIDAD.X = this.contenidoSeleccionado.X;
		this.contenidoSeleccionado.ENTIDAD.Y = this.contenidoSeleccionado.Y;

		this.contenidoSeleccionado.ENTIDAD.FechaAlta = this.contenidoSeleccionado.FechaAlta;
		this.contenidoSeleccionado.ENTIDAD.FechaBaja = this.contenidoSeleccionado.FechaBaja;

		this.confirmacionVisible = false;

		const that = this;
		const token = that.authService.getToken();
		const idEspacio = that.authService.getIdEspacio();
		const idAla =  that.contenidoSeleccionado.ALA_PLANO.Id;

		return that.sws.wsObtenerLLFromXY(token, that.contenidoSeleccionado.X, that.contenidoSeleccionado.Y, idEspacio, idAla).toPromise()
		.then(function (ll) {
			that.contenidoSeleccionado.ENTIDAD.Latitud = ll.Latitud;
			that.contenidoSeleccionado.ENTIDAD.Longitud = ll.Longitud;

			return that.entityManagerProvider.saveChanges();
		})
		.then(function(msg) {
			that.onElementoGuardado.emit({ result: true, element: that.contenidoSeleccionado });
			that.spinner.style.display = 'none';
			return msg;
		})
		.then(function(data: any) {
			console.log(data)
			// Renovamos el Token
			if(data.httpResponse.status === 200){
				that.authService.relogin();
			}
		})
		.catch(function(err) {
			that.onElementoGuardado.emit({ result: false, element: that.contenidoSeleccionado });
			that.spinner.style.display = 'none';
			return err;
		});
	}

	aplicar(){
		this.blockUI = document.getElementsByClassName('blockPosicionarContenido')[0] as HTMLElement;
		this.blockUI.style.display = 'inherit';
	}

	posicionar(){
		this.blockUI = document.getElementsByClassName('blockPosicionarContenido')[0] as HTMLElement;
		this.blockUI.style.display = 'none';
	}

	comprobarPermisos() {
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.permisosService.getPermisosUsuario(userId)
		.then(function(perm){
			that.permisos = perm;
		});
	}
	onFechaAceptar(dt, calendar, columna, tipo) {
		console.log(calendar);
		const fecha = calendar.value ? calendar.value : new Date();
		if (tipo === 'FechaAlta') {
			this.contenidoSeleccionado.FechaAlta = fecha;
		}
		if (tipo === 'FechaBaja') {
			this.contenidoSeleccionado.FechaBaja = fecha;
		}
		calendar.overlayVisible=false;
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioContenido.component.ts